export default __webpack_public_path__ + "static/media/pcidss.8e62f6c0.svg";